// import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NexusFormResultComponent } from './components/nexus-form-result/nexus-form-result.component';
import { NexusComponent } from './components/nexus/nexus.component';
import { EventService } from './services/event.service';
// import { ModuleWithProviders } from '@angular/compiler/src/core';
import { NexusFormDateInputComponent } from './components/nexus-form-date-input/nexus-form-date-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MembershipService } from './services/membership.service';
import { AuthenticationGuard } from './guards/authentication.guard';
import { RegionService } from './services/region.service';
import { RegionsResolver } from './resolvers/regions.resolver';
import { NexusInjector } from './nexus.injector';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NexusInvoiceInformationComponent } from './components/nexus-invoice-information/nexus-invoice-information.component';
import { NgPipesModule } from 'ngx-pipes';
import { MatCardModule } from '@angular/material/card';
import { MomentModule } from 'ngx-moment';
import { TutorialDialogComponent } from './components/tutorial-dialog/tutorial-dialog.component';
import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { SurveyQuestionComponent } from './components/survey-question/survey-question.component';
import { SurveyQuestionDialogComponent } from './components/survey-question-dialog/survey-question-dialog.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PasswordLinkResolver } from './resolvers/password-link-resolver';
import { EmailResolver } from './resolvers/email.resolver';
import { CreditReportingFormComponent } from '../components/settings/credit-reporting-form/credit-reporting-form.component';

@NgModule({
  declarations: [
    NexusFormResultComponent,
    NexusComponent,
    NexusFormDateInputComponent,
    NexusInvoiceInformationComponent,
    TutorialDialogComponent,
    SurveyQuestionComponent,
    SurveyQuestionDialogComponent,
    CreditReportingFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgPipesModule,
    MatCardModule,
    MomentModule,
    FontAwesomeModule,
    MatDialogModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatFormFieldModule
  ],
  exports: [
    NexusFormResultComponent,
    NexusFormDateInputComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    NexusInvoiceInformationComponent,
    SurveyQuestionComponent,
    SurveyQuestionDialogComponent,
    CreditReportingFormComponent
  ]

})
export class CoreModule {

  constructor(injector: Injector) {
    NexusInjector.setInjector(injector);

  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        provideNgxMask(),
        MembershipService,
        EventService,
        RegionService,
        AuthenticationGuard,
        RegionsResolver,
        PasswordLinkResolver,
        EmailResolver
      ]
    };
  }
}
